module.exports = __webpack_public_path__ + "img/logo.b7b3187b.svg";